<ion-content class="signUp-content" *ngIf="!issToken()">
  <div class="signup-wrap" lang="en">
    <div>
      <div>
        <div>
          <ion-fab vertical="top" horizontal="start" slot="fixed">
            <ion-icon name="arrow-back" class="close-fab" [routerLink]="['/welcome']" routerDirection="back"></ion-icon>
          </ion-fab>
        </div>
        <div class="login-text-position">
          <h3 class="ion-text-center login-text">
            {{'LOGINPAGE.Welcome' | translate}}<br />
            {{'LOGINPAGE.back' | translate}}
          </h3>
        </div>
      </div>

      <!-- <div class="social-login">
      <ion-row (click)="socialLogin('facebook')">
        <ion-col class="social-text" size="10">
          <h1>Login with facebook</h1>
        </ion-col>
        <ion-col class="icon-wrapper" size="2"
          ><img src="../../../assets/icon/facebook.png" alt="" class="social-icon"
        /></ion-col>
      </ion-row>
      <ion-row (click)="socialLogin('facebook')">
        <ion-col class="social-text" size="10">
          <h1>Login with Google</h1>
        </ion-col>
        <ion-col class="icon-wrapper" size="2"
          ><img src="../../../assets/icon/gmail.png" alt="" class="social-icon"
        /></ion-col>
      </ion-row>
    </div> -->

    <!-- <select #langSelect (change)="onChange(langSelect.value)">
    <option *ngFor="let lang of languageArray" [value]="lang">{{ lang }}</option>
  </select> -->
  <div>
    @if (!formType) {
    @defer (when !formType; prefetch on idle) {
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm.value, loginForm.valid)" class="signup-form-size">
      <div class="login-form">
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col size="3.2" class="ion-no-padding">
              <ion-item class="ion-no-padding" lines="none">
                <ion-input type="tel" formControlName="dialCode" min="1" maxlength="4" placeholder="+44" (input)="checkInput($event)" (keypress)="numericOnly($event)" class="login-input"></ion-input>
                <input id="dialCode"  style="display: none;"
                  (countryChange)="onCell1CountryChange($event)" readonly />
                </ion-item>
              </ion-col>
              <ion-col size="0.3" class="ion-no-padding"></ion-col>
              <ion-col size="8.5" class="ion-no-padding">
                <ion-item id="border-custom" class="country-select ion-no-padding"
                  [ngClass]="loginForm.get('phoneNumber')?.errors?.incorrectPhoneNumber ? 'invalid-field': ''" lines="none">
                  <input type="tel" placeholder="{{'LOGINPAGE.Mobile' | translate}}" maxlength="11"
                    (keypress)="numericOnly($event)" accesskey="p" (hasError)="phoneNumberHasError($event)"
                    class="password-alignment login-phone-number"
                    (input)="getPhoneNumber($event)"
                    formControlName="phoneNumber" />
                  </ion-item>
                </ion-col>
              </ion-row>
            </ion-grid>
            @if (loginForm.get('phoneNumber')?.errors?.incorrectPhoneNumber) {
              <div class="errorContainer">
                <ion-icon name="warning" class="icon"></ion-icon>
                @if (phoneInValid) {
                  <span class="text"> {{'LOGINPAGE.mobile number' | translate}}</span>
                }
                @if (!phoneInValid) {
                  <span class="text">{{'LOGINPAGE.Please number' | translate}}</span>
                }
              </div>
            }

            <ion-item
              lines="none"
              [ngClass]="loginForm.get('password').touched && loginForm.get('password')?.errors ? 'invalid-field': ''"
              class="ion-no-padding push-back"
              >
              <ion-input
                [type]="passwordType"
                clearOnEdit="false"
                placeholder="{{'LOGINPAGE.Password' | translate}}"
                formControlName="password"
                class="password-alignment"
                minlength="6"
                maxlength="20"
                [ngClass]="(loginForm.get('password').value?.length > 0 && passwordIcon === 'eye-off') ? 'password-spacing': 'password-revealed'"
                >
              </ion-input>
              @if (passwordIcon === 'eye-off') {
                <img
                  class="password-reveal-icon"
                  width="35"
                  height="35"
                  src="assets/icon/eye.svg"
                  (click)="toggleViewPassword()"
                  alt="eye"
                  />
              }
              @if (passwordIcon === 'eye') {
                <img
                  class="password-reveal-icon"
                  width="35"
                  height="35"
                  src="assets/icon/eye-off.svg"
                  (click)="toggleViewPassword()"
                  alt="eye-off"
                  />
              }
            </ion-item>
          </div>

          @if (loginForm.get('password').touched && loginForm.get('password')?.errors?.required) {
            <div
              class="errorContainer"
              >
              <ion-icon name="warning" class="icon"></ion-icon>
              <span class="text">{{'LOGINPAGE.enter password' | translate}}</span>
            </div>
          }
          @if (loginForm.get('password').touched && loginForm.get('password')?.errors?.minlength) {
            <div
              class="errorContainer"
              >
              <ion-icon name="warning" class="icon"></ion-icon>
              <span class="text">{{'LOGINPAGE.valid password' | translate}}</span>
            </div>
          }

          <ion-button expand="block" class="action-btn-large" type="submit" [disabled]="loginForm.invalid" (click)="hotJarEvents('user_login')">
            {{'LOGINPAGE.LOGINBUTTON' | translate}}</ion-button
            >
          </form>
        }
        <div class="forget-pass-txt" aria-hidden="true">
          <p class="lost-password">
            {{'LOGINPAGE.Forgot' | translate}}
            <a class="text-link" (click)="openForgetPassword(); hotJarEvents('forgot_password')">{{'LOGINPAGE.Click here' | translate}}</a>
          </p>
        </div>
        <div class="forget-pass-txt" aria-hidden="true">
          <p class="lost-password">
            <a class="text-link" (click)="formType = true;">{{'LOGINPAGE.login_with_email' | translate}}</a>
          </p>
        </div>
        <div id="captcha-container"></div>
        }
        @if (formType) {
          @defer (when formType; prefetch on idle) {
          <div class="firebaseUI">
            <firebase-ui (signInSuccessWithAuthResult)="successCallback($event)" (signInFailure)="errorCallback($event)"
            (uiShown)="uiShownCallback()"></firebase-ui>
          </div>
          <div class="forget-pass-txt" aria-hidden="true">
            <p class="lost-password">
              <a class="text-link" (click)="formType = false;">{{'LOGINPAGE.login_with_mobile' | translate}}</a>
            </p>
          </div>
        }
        @placeholder {
          <span></span>
        }
        @error {
          <div class="forget-pass-txt">
            <p class="lost-password">
              {{ 'LOGINPAGE.login_with_mobile' | translate }}
            </p>
          </div>
        }
      }
        <!-- lang selection code -->
        <div class="selection-wrapper">
          <div class="lang-wrapper input-sm">
            <select #langSelect (change)="onLanguageChange(langSelect.value)" title="Language"
              [(ngModel)]="selectedLanguage" [ngModelOptions]="{standalone: true}">
              @for (lang of languageArray; track lang) {
                <option [value]="lang.language_code">
                  {{ lang.language_name }}
                </option>
              }
            </select>
          </div>
        </div>
        <!-- END login page Dropdown -->

        <!-- trademark start -->
          <div class="footer-trademark">
            <img alt="LottoSocial" src="../../assets/icon/lotto_social.svg"> LottoSocial
          </div>
        <!-- trademark end -->
         
        <!-- login page Dropdown -->

        <!--         <div class="content_holder">
        <div class="name_holder">
          <span class="for_aline"> {{'LOGINPAGE.Change' | translate}}</span>
        </div>
        <div class="flag_div_holder">
          <div class="animation">
            <div class="flags_holder">
              <div class="scroll_be" [class]="isShowDiv ? 'one' : 'two'" (click)="toggleDisplayDiv()">
                <div
                  *ngFor="let f of flag"
                  class=""
                  [class]="isShowDiv ? 'flag_css ' : 'flag_css2'"
                  (click)="onLanguageSelect(f)"
                  >
                  <img [src]="f.img" class="Img_flag" alt="" />
                  <p class="t">{{f.name}}</p>
                </div>
              </div>

              <div class="change">
                <div class="bt" (click)="toggleDisplayDiv()">
                  <div class="innter_button">
                    <img [src]="selectedFlag.img" class="Img_flag" alt="" />
                    <p class="tt">{{selectedFlag.name}}</p>
                    <img
                      src="../../../assets/icon/down-arrow.svg"
                      width="12px"
                      [class]="isShowDiv ? 'arrw ' : 'arrw2'"
                      alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

      </div>
    </div>
  </div>
</ion-content>
